export default {
  error: {
    tooBig: 'Le fichier est trop volumineux (maximum : {maxSize} {unit})'
  }
}
